
<iframe
    #drawingToolIframe
    id="drawingToolIframeID"
    class="drawingToolIframe"
    (load)="uploadDrawingToolIframe()"
    [src]="drawingToolUrl | safeUrl" >
</iframe>
